module.exports = "/_next/static/images/6230edc79503a9f2d98f15a09a7f09c1-exame.png.webp";